import React, { useEffect, useState } from "react";
import "./Loader.scss";
import { TemplateObject } from "../../../Models/TemplateObject";
type Props = {
  loaderProps: TemplateObject;
};
const ReactLoader = ({ loaderProps }: Props) => {
  return (
    <>
      <div className={"react-loader " + loaderProps.showloader}>
        <div className="lds-roller">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    </>
  );
};

export default ReactLoader;
